const FOOD_MOODS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: [],
  latestEvent: undefined,
  data: [],
  isDirty: false,
  dataForRenaming: undefined,
}

export default FOOD_MOODS_INITIAL_STATE
